module.exports = __webpack_public_path__ + "static/media/Lumineon_gaussian2.180ddcd2.png";